<template>
	<div id="app" v-touch:right="onSwipeLeft">
    <router-view v-if="loaded"/>
		       <!-- <div class="download_box" v-if="is_show_footer && app.is_disable === 'Y' && is_show_down_app">
            <a :href="app.app_link" class="down">
                <div class="down_left">
                    <span class="app_logo" v-bind:style="{'background-image':'url(' + app.image + ')'}"></span>
                    <div class="app_info">
                        {{app.text1}}<br>{{app.text2}}
                    </div>
                </div>
                <div class="right">App客户端</div>
            </a>
            <span class="close_down" @click="closeDownApp"></span>
        </div> -->
		<div v-if="is_show_footer" class="footer">
			<router-link to="/" class="footer_item" :class="show_icon_type === 'index' ? 'footer_item_active' : ''">
				<van-icon name="wap-home" size="30"/>
				<p class="footer_info">
					{{$t('home.index')}}
				</p>
			</router-link>
			<router-link to="/activity" class="footer_item" :class="show_icon_type === 'cart' ? 'footer_item_active' : ''">
				<van-icon name="gem" size="30"/>
				<p class="footer_info">
					{{$t('home.activity')}}
				</p>
			</router-link>
			<router-link to="/item" class="footer_item">
				<div class="grab_wrap"></div>
			</router-link>
			<router-link to="/share" class="footer_item" :class="show_icon_type === 'share' ? 'footer_item_active' : ''">
				<van-icon name="cluster" size="30"/>
				<p class="footer_info">
					{{$t('share.team')}}
				</p>
			</router-link>
			<router-link to="/user" class="footer_item" :class="show_icon_type === 'user' ? 'footer_item_active' : ''">
				<van-icon name="manager" size="30"/>
				<p class="footer_info">
					{{$t('home.my')}}
				</p>
			</router-link>
		</div>
		<div v-show="real_name" class="real_name_mask">
			<div class="real_box">
				<div class="tit" />
				<p class="tips">
					请先设置钱包余额支付密码！
				</p>
				<div class="basic_btn" @click="real_name = false">
					立即设置
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Dialog
	} from 'vant';
	import Fetch from "./utils/fetch";

	export default {
		name: 'App',
		data() {
			return {
				show_icon_type: 'index',
				real_name: false,
				is_show_down_app: true,
				is_show_footer: true,
				sync_timer: null,
				app: {},
        loaded:false
			}
		},
		updated() {
			document.body.scrollTop = 0
			document.documentElement.scrollTop = 0
		},
		mounted() {
			this.start();
		},
		methods: {
			onSwipeLeft (even,start,end) {
				console.log();
				if(end['X']-start['X']>60){
					this.$router.go(-1);
				}
			},
			bigNumeber(str) {
				var str = str.toString();
				var strs = str.split(".");
				var s1 = strs[0] || 0;
				var s2 = strs[1] || "00"
				return `<span class="bigNum">${s1}</span><span>.</span><span>${s2}</span>`;
			},
			numFilter(value) {
				let transformVal = parseFloat(value).toFixed(3)
				let realVal = transformVal.substring(0, transformVal.length - 1)
				return parseFloat(realVal)
			},
			footer: function(type = 'index', show_footer = true) {
				if (type == 'walfare') {
					document.getElementById('app').style.paddingBottom = '0';
				} else {
					document.getElementById('app').style.paddingBottom = '1.333333rem';
				}
				this.show_icon_type = type;
				this.is_show_footer = show_footer;
			},
			start() {

				Fetch("/index/webconfig").then((r) => {
					this.app = r.data;
					window.document.title = r.data.title;
					  this.$i18n.locale = r.data.lang;
					  localStorage.setItem("lang", r.data.lang);
					  localStorage.setItem("moneyMark", r.data.money_mark);
					  this.loaded = true;
				});

				this.sync_timer = setInterval(() => {
					this.sync()
				}, 3000);
			},
			closeDownApp() {
				this.is_show_down_app = false;
			},
			sync() {
				/* Fetch("/index/sync", {}, null, false).then((r) => {
				     if (r.data.is_open_notice_dialog) {
				         this.openNoticeDialog();
				     }
				 }); */
			},
			close() {
				this.show_anwser = false;
			},
			openNoticeDialog() {
				Dialog.confirm({
					title: '提示',
					message: '您有新消息，是否前往查看?'
				}).then(() => {
					this.$router.push('/notice');
				}).catch(() => {

				});
			},
		}
	}
</script>
<style lang="less">
	.basic_wrap{
		padding-top: 64px;
	}
	
	// @import "./assets/font/font.css";
	.kefu {
		width: 80px;
		height: 80px;
		position: fixed;
		z-index: 10;
		right: 13px;
		bottom: 50px;
		transition: all 1s;
		opacity: 1;
		transform: translateX(0);
		z-index: 80;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.kefu.kefu_hide {
		transform: translateX(70%);
		opacity: 0.5;
	}

	.numberFont {
		font-family: barlow !important;
		font-size: 15px !important;
		font-weight: bold !important;
		span:nth-of-type(3) {
			font-size: 14px !important;
		}
		span:nth-of-type(4) {
			font-size: 12px !important;
		}
	}

	html,
	body {
		width: 100%;
		height: 100%;
		overflow-y: scroll;
	}

	html::-webkit-scrollbar,
	body::-webkit-scrollbar {
		width: 0px;
		height: 0px;
	}

	body {
		margin: 0;
	}

	.bigNum {
		font-size: 18px !important;
	}

	.fh {
		font-size: 12px !important;
	}

	.larfont .fh {
		margin-top: 3px;
	}

	.wan {
		font-size: 14px;
		margin-top: 2px;
	}

	.numberFontBold {
		span:first-child {
			font-size: 12px;
			margin-top: 4px;
		}

		span:last-child {
			margin-top: 2px;
		}
	}

	#app {
		padding-bottom: 65px !important;
		min-height: 100%;
		height: auto;
		width: 100%;
		max-width: 375px;
		background-color: #FAFAFA;
		background-image: url(./assets/images/bg.png);
	}

	#app .download_box {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		position: fixed;
		margin: 0 auto;
		left: 0;
		right: 0;
		height: 45px;
		width: 100%;
		max-width: 375px;
		background: rgba(0, 0, 0, 0.5);
		bottom: 50px;
		padding: 0 3.6%;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
		z-index: 10;
	}

	#app .download_box .down {
		-webkit-box-flex: 1;
		-ms-flex: 1 1 auto;
		flex: 1 1 auto;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		padding-right: 10px;
	}

	#app .download_box .down .down_left {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
	}

	#app .download_box .down .down_left .app_logo {
		display: inline-block;
		width: 40px;
		height: 40px;
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
		background-image: url(./views/images/home/app_logo.svg);
		margin-right: 14px;
		;
	}

	#app .download_box .down .down_left .app_info {
		font-size: 12px;
		color: #fff;
		line-height: 1.5;
		;
	}

	#app .download_box .down .right {
		background: #D8232C;
		padding: 5px 5px;
		color: #ffffff;
		border-radius: 5px;
		font-size: 12px;
	}

	#app .download_box .close_down {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 20px;
		flex: 0 0 20px;
		height: 45px;
		;
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
		background-image: url(./views/images/home/close.svg);
	}

	#app .footer {
		position: fixed;
		margin: 0 auto;
		left: 0;
		right: 0;
		-webkit-box-flex: 0;
		-ms-flex: 0 0 48px;
		flex: 0 0 48px;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-pack: distribute;
		justify-content: space-around;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		background: -webkit-linear-gradient(left,#00e6ff,#9883d6);
    	background: linear-gradient(90deg,#00e6ff,#9883d6);
		border-top-left-radius: 10px;
    	border-top-right-radius: 10px;
		box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.2);
		width: 100%;
		max-width: 750px;
		bottom: 0;
		height: 60px;
		z-index: 4;
	}

	#app .footer .footer_item {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
		cursor: pointer;
		color: #999999;
		width: 60px;
	}
	#app .footer .footer_item .grab_wrap {
		position: absolute;
		left: 50%;
		-webkit-transform: translateX(-50%);
		transform: translateX(-50%);
		width: 60px;
		height: 60px;
		bottom: 10px;
		//box-shadow: 1px 1px 1px rgb(51 51 51);
		border-radius: 50%;
		z-index: 200;
	}
	#app .footer .footer_item .grab_wrap::before{
		position: absolute;
		content: "";
		width: 60px;
		height: 60px;
		top: 0;
		left: 0;
		z-index: 1;
		border-radius: 50%;
		opacity: .9;
	}
	#app .footer .footer_item .grab_wrap::after {
		position: absolute;
		z-index: 2;
		content: "";
		left: 0;
		right: 0;
		bottom: 0;
		top: 0;
		background: url(data:image/png;base64,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) no-repeat;
		background-size: 100% 100%;
	}
	#app .footer .footer_item .footer_icon {
		display: inline-block;
		width: 26px;
		height: 26px;
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
		margin-bottom: 6px;
	}

	// #app .footer .footer_item .footer_icon.footer_icon_home {
	// 	background-image: url(./views/images/common/home.png);
	// }

	// #app .footer .footer_item .footer_icon.footer_icon_task {
	// 	background-image: url(./views/images/common/item.png);
	// }

	// #app .footer .footer_item .footer_icon.footer_icon_cart {
	// 	background-image: url(./views/images/common/activity.png);
	// }

	// #app .footer .footer_item .footer_icon.footer_icon_user {
	// 	background-image: url(./views/images/common/user.png);
	// }

	#app .footer .footer_item .footer_info,#app .footer .footer_item .van-icon {
		font-size: 12px;
		margin: 2px;
		color: #000000;
		font-weight: bold;
	}

	#app .footer .footer_item.footer_item_active .footer_info,#app .footer .footer_item.footer_item_active .van-icon {
		color: #3775f4;
		font-weight: bold;
		//background: -webkit-linear-gradient(left,#00e6ff,#6439e1);
		//background: linear-gradient(45deg,#00e6ff,#6439e1);
		//background-clip: text;
		//-webkit-background-clip: text;
		//-webkit-text-fill-color: rgba(141,52,52,0);
	}

	// #app .footer .footer_item.footer_item_active .footer_icon.footer_icon_home {
	// 	background-image: url(./views/images/common/home_cur.png);
	// }

	// #app .footer .footer_item.footer_item_active .footer_icon.footer_icon_task {
	// 	background-image: url(./views/images/common/item_cur.png);
	// }

	// #app .footer .footer_item.footer_item_active .footer_icon.footer_icon_cart {
	// 	background-image: url(./views/images/common/activity_cur.png);
	// }

	// #app .footer .footer_item.footer_item_active .footer_icon.footer_icon_user {
	// 	background-image: url(./views/images/common/user_cur.png);
	// }

	.red_top_bg {
		width: 100%;
		max-width: 750px;
		height: 44px;
		margin: 0 auto;
		background: #FFF;
		background-size: 100% 100%;
		overflow: hidden;
	}

	.top_right {
		position: absolute;
		font-size: 13px;
		line-height: 18px;
		color: #FFFFFF;
		top: 16px;
		right: 14px;
	}

	.limit {
		height: 20px;
		line-height: 20px;
		border-radius: 10px;
		background: rgba(241, 34, 17, 0.08);
		color: #f12211;
		text-align: center;
		padding: 0 7px;
		border: 1px solid #f12211;
		font-size: 12px;
	}

	.gray_btn {
		height: 20px;
		display: flex;
		align-items: center;
		background: rgba(0, 0, 0, 0.3);
		font-size: 12px;
		text-align: center;
		color: #FFFFFF;
		border-radius: 10px;
		padding: 0 9px;
	}

	.big_tit {
		position: absolute;
		height: 25px;
		font-size: 18px;
		font-weight: 500;
		color: rgba(255, 255, 255, 1);
		line-height: 25px;
		top: 12px;
		left: 50%;
		transform: translateX(-50%);
	}

	.sub_btn {
		background: linear-gradient(123deg, #e3382e, #ff4d15);
		height: 36px;
		line-height: 36px;
		font-size: 12px;
		color: #FFFFFF;
		text-align: center;
		width: 94px;
		border-radius: 18px;
	}

	.remove_btn {
		background: linear-gradient(117deg, rgba(254, 166, 0, 1) 0%, rgba(255, 188, 0, 1) 100%);
		height: 36px;
		line-height: 36px;
		font-size: 12px;
		color: #FFFFFF;
		text-align: center;
		width: 94px;
		border-radius: 18px;
	}

	.home_tit {
		width: 100%;
		height: 22px;
		line-height: 22px;
		display: flex;
		align-items: center;
		justify-content: center;

		.line {
			width: 75px;
			height: 2px;
		}

		h5 {
			font-size: 16px;
			line-height: 22px;
			color: #000000;
			margin: 0 10px;
			font-weight: bold;
		}
	}

	.van-popup {
		max-width: 100%;
		margin: 0 auto;
		right: 0;
	}

	.back_left {
		width: 20px;
		height: 20px;
		background: url(./views/images/item/back.png) no-repeat center center;
		background-size: auto 100%;
		margin: 12px 0 0 8px;
	}

	.basic_btn {
		height: 45px;
		line-height: 45px;
		font-size: 16px;
		width: 90%;
		background: linear-gradient(90deg, #00e6ff, #6439e1);
		border-radius: 23px;
		color: #FFFFFF;
		text-align: center;
	}

	.basic_btn.no_touch {
		color: rgba(255, 255, 255, 0.5);
	}

	.flex_center {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.wrap_box {
		width: 100%;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
	}

	.eye_bi {
		width: 21px;
		height: 25px;
		background: url(./views/images/user/eye2.png) no-repeat center center;
		background-size: 100% auto;

		&.eye {
			background: url(./views/images/user/eye1.png) no-repeat center center;
			background-size: 100% auto;
		}
	}

	.real_name_mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 30;
		background-color: rgba(0, 0, 0, 0.95);

		.real_box {
			width: 272px;
			height: 185px;
			background: rgba(255, 255, 255, 1);
			border-radius: 8px;
			position: absolute;
			top: 50%;
			left: 0;
			right: 0;
			margin: -92px auto 0 auto;

			.tit {
				width: 77px;
				height: 67px;
				position: absolute;
				top: -35px;
				left: 50%;
				transform: translateX(-50%);
				background: url(./views/images/user/tit.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.tips {
				width: 185px;
				height: 50px;
				text-align: center;
				font-size: 18px;
				color: #000000;
				line-height: 25px;
				position: absolute;
				top: 49px;
				left: 50%;
				transform: translateX(-50%);
			}

			.basic_btn {
				width: 225px;
				position: absolute;
				left: 0;
				right: 0;
				margin: 0 auto;
				bottom: 15px;
			}
		}
	}

	.contract_box img {
		width: 100%;
	}
</style>
